const mEditionAcademyUsers = {
  mEditionAcademyUsers: {
    alerts: {
      createAcademiaActorResetPassword: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'Los datos para restablecer la contraseña fueron enviados exitosamente'
      },

      readAcademiaUsuariosExportar: {
        error: 'Un error ha ocurrido. Espera un momento y vuelve a intentarlo.',
        success: 'Listado de usuarios descargado.'
      }
    },

    buttonPrimary: 'Descargar CSV',

    buttonSecondary: {
      createText: 'Crear Usuario',
      downloadText: 'Descargar CSV',
      filterText: 'Filtros Avanzados'
    },

    files: {
      users: 'usuarios'
    },

    table: {
      thAccess: 'Acceso',
      thActors: 'Roles',
      thCountry: 'País',
      thDate: 'Fecha De Alta',
      thProfile: 'Perfil',
      thUser: 'Usuario'
    },

    tooltip: {
      access: 'Reenviar Acceso',
      actors: 'Ver Roles',
      profile: 'Ver Perfil',
      reload: 'Actualizar'
    }
  }
}

export default mEditionAcademyUsers
